module.exports = __webpack_public_path__ + "img/3.2bf56d22.jpg";